import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';

import { fetchSchoolConfig } from '../redux/slices/SchoolConfigSlice';
import { AppDispatch, RootState } from '../redux/store';
import { SchoolConfig } from '../types/schoolConfigType';

export const useSchoolConfig = (): SchoolConfig | undefined => {
  const dispatch = useDispatch<AppDispatch>();
  const { schoolConfig } = useSelector(
    (state: RootState) => state.schoolConfig
  );
  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );
  const school = loggedInUser?.school;

  const [config, setConfig] = useState<SchoolConfig | undefined>(schoolConfig);

  useEffect(() => {
    if (isEmpty(school)) {
      console.error('Failed to fetch config, as school is undefined');
      setConfig(undefined as unknown as SchoolConfig);
      return;
    }

    const fetchConfig = async () => {
      try {
        const action = await dispatch(fetchSchoolConfig(school));
        const result = unwrapResult(action);
        setConfig(result as unknown as SchoolConfig);
      } catch (error) {
        console.error('Failed to fetch config:', error);
      }
    };

    if (schoolConfig?.school !== school) {
      fetchConfig();
    }
  }, [school, schoolConfig, dispatch]);

  return config;
};
